/*

Drag-and-Drop mixin

Usage:

  Add to your component: @dragover="dragOver" @drop="drop"

  You can check if you're dragging: this.isDragging

  If you have a target, add to that component: @dragenter="dragEnter" @dragleave="dragLeave"

  You can check if you're in the target: this.isOverDropTarget

Optional callbacks:

  called after "dragOver":
    dragOverHandler(event, isOverDropTarget)

  called after: "dropOver"
    dropHandler(event, data, isOverDropTarget)

  called when on timeout:
    dropTimeoutHandler(isOverDropTarget)

*/
const dropTimerTimeout = 500

export default {
  data: function () {
    return {
      isDragging: false,
      isOverDropTarget: false,
      dropTimer: null
    }
  },
  methods: {
    dragEnter: function () {
      this.isOverDropTarget = true
    },
    dragLeave: function () {
      this.isOverDropTarget = false
    },
    dragOver: function (event) {
      this.isDragging = true

      event.dataTransfer.effectAllowed = 'copy'
      event.dataTransfer.dropEffect = 'copy'

      event.preventDefault()

      if (this.dropTimer) {
        clearTimeout(this.dropTimer)
      }

      this.dropTimer = setTimeout(
        () => {
          this.isDragging = false
          if (this.dropTimeoutHandler) {
            return this.dropTimeoutHandler(this.isOverDropTarget)
          }
        }, dropTimerTimeout
      )

      if (this.dragOverHandler) {
        return this.dragOverHandler(event, this.isOverDropTarget)
      }
    },
    drop: function (event) {
      this.isDragging = false
      event.preventDefault()

      const data = this.processEvent(event)

      if (this.dropHandler) {
        return this.dropHandler(event, data, this.isOverDropTarget)
      }
    },
    processEvent: function (event) {
      let files = false
      let uri = false

      if (event.dataTransfer.types.length > 0) {
        const type = event.dataTransfer.types[0]
        const type2 = event.dataTransfer.types.length > 1 ? event.dataTransfer.types[1] : null
        if (type === 'Files' || type2 === 'Files') {
          files = event.dataTransfer.files
        } else if (type === 'text/html' || (type === 'text/uri-list' && type2 === 'text/html')) {
          // is there an img tag?
          const div = document.createElement('div')
          div.innerHTML = event.dataTransfer.getData('text/html').trim()
          div.childNodes.forEach((child) => {
            if (child.nodeName.toLowerCase() === 'img') {
              uri = child.src
            }
          })
        } else if (type === 'text/uri-list' || type === 'text/plain') {
          uri = event.dataTransfer.getData(type)
        }
      }

      const data = { file: null, uri: null, mode: null, image: false }

      if (uri) {
        data.uri = uri
        data.mode = 'link'

        const extension = uri.split('.').pop()
        if (extension === 'jpg' || extension === 'jpeg' || extension === 'gif' || extension === 'png' || extension === 'svg') {
          data.image = true
        } else if (uri.substring(0, 11) === 'data:image/') {
          data.image = true
          data.mode = 'image'
        }
      }

      if (files) {
        data.file = files[0]
        data.mode = 'file'
      }

      return data
    }
  }
}
